import { css, keyframes } from '@backyard-ui/styles';

const fade = keyframes({
  'from, to': {
    opacity: 0.5,
  },
  '50%': {
    opacity: 1,
  },
});

const baseStyles = css({
  width: '$$width',
  height: '$$height',
  overflow: 'hidden',
  cursor: 'default',
  userSelect: 'none',
  pointerEvents: 'none',
  background: '$n100',
  '&::before, &::after, *': {
    visibility: 'hidden',
  },
  variants: {
    isCircle: {
      true: {
        borderRadius: '$full',
      },
      false: {
        borderRadius: '$sm',
      },
    },
    hasAnimation: {
      true: {
        animation: `${fade} 1500ms linear infinite`,
      },
    },
  },
  defaultVariants: {
    isCircle: false,
    hasAnimation: true,
  },
});

export default baseStyles;
